import React from "react";
import { Event as EventIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { Usage } from "fond/types";
import { formatDateString } from "fond/utils/dates";

import { Container, StyledBox, StyledIcon, StyledText } from "./subscriptionPeriod.styles";

interface SubscriptionPeriodProps {
  subscriptionUsage: Usage;
}

const SubscriptionPeriod: React.FC<SubscriptionPeriodProps> = ({ subscriptionUsage }: SubscriptionPeriodProps) => {
  const theme = useTheme();
  const startDate = formatDateString(subscriptionUsage.StartDate);
  const endDate = formatDateString(subscriptionUsage.EndDate);

  return (
    <Container elevation={1}>
      <StyledBox>
        <>
          <StyledIcon color="primary">
            <EventIcon data-testid="subscription-period-active-icon" />
          </StyledIcon>
          <StyledText color={theme.palette.biarri.secondary.grey}>{`Current billing period: ${startDate} - ${endDate}`}</StyledText>
        </>
        <StyledText color={theme.palette.biarri.secondary.grey}>(UTC)</StyledText>
      </StyledBox>
    </Container>
  );
};

export default SubscriptionPeriod;
